import { Heading, Text } from '@buffer-mono/popcorn'

import { ConnectSupportedChannelsCard } from '~publish/pages/Community/components/EmptyStates/ConnectSupportedChannelsCard'

import styles from './NoSupportedChannelsEmptyState.module.css'

import type { JSX } from 'react'

const ILLUSTRATION_URL =
  'https://buffer-publish.s3.us-east-1.amazonaws.com/images/comments-empty-allchannels.svg'

type NoSupportedChannelsEmptyStateProps = {
  /**
   * Hide the connect-supported-channels card. Set for actors who can't manage
   * channels (e.g. a non-admin team member): the illustration and copy still
   * render, but the connect CTA is dropped because prompting them to connect a
   * channel they can't connect would be misleading (CORE-6008). Defaults to
   * `false` (actor can connect — the connect card is the point).
   */
  hideConnectCta?: boolean
}

export function NoSupportedChannelsEmptyState({
  hideConnectCta = false,
}: NoSupportedChannelsEmptyStateProps = {}): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <img
          src={ILLUSTRATION_URL}
          alt=""
          className={styles.illustration}
          aria-hidden
        />
        <div className={styles.copy}>
          <Heading size="sm" align="center" className={styles.title}>
            Reply to all your social media comments in one place ✨
          </Heading>
          <Text color="subtle">
            Stop juggling tabs and apps. Manage every conversation from a
            single, distraction-free inbox.
          </Text>
        </div>
      </div>
      {!hideConnectCta && (
        <ConnectSupportedChannelsCard hint="Connect one of the supported channels to start interacting with your audience." />
      )}
    </div>
  )
}
